export default {"src":"/_next/static/media/GATE.b28e5083.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};